import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

const copy = {
  heading: `Is your customer data strategy best-in-class?`,
  description: `Use Segment’s Customer Data Maturity Model to evaluate your data strategy and receive actionable recommendations on how to improve.`,
}

const Hero = () => (
  <Wrapper>
    <HeroComponent variant="centered">
      <HeroRecipe.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </HeroRecipe.Copy>
    </HeroComponent>
  </Wrapper>
)

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const HeroComponent = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    gap: 0;
  }
`

export default Hero
